var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaTerror2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.682 112.44C170.682 149.683 142.821 168.305 109.706 179.106C107.972 179.656 106.089 179.629 104.373 179.031C71.1786 168.305 43.3175 149.683 43.3175 112.44V60.2984C43.3175 58.3228 44.1562 56.4282 45.649 55.0313C47.1419 53.6344 49.1666 52.8496 51.2778 52.8496C67.1984 52.8496 87.0992 43.9111 100.95 32.589C102.637 31.2408 104.782 30.5 107 30.5C109.218 30.5 111.363 31.2408 113.05 32.589C126.98 43.9856 146.802 52.8496 162.722 52.8496C164.833 52.8496 166.858 53.6344 168.351 55.0313C169.844 56.4282 170.682 58.3228 170.682 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_30717)",
    stroke: "url(#paint1_linear_2162_30717)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 84L108 64.5L142 84V129L107.5 145L70.5 127.5L71.5 84Z",
    fill: "url(#paint2_linear_2162_30717)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143 126.3V84.7L107 65.5L71 84.7V126.3L107 145.5L143 126.3ZM67 128.7L147 82.3L67 128.7ZM67 82.3L147 128.7L67 82.3ZM107 65.5V145.5V65.5Z",
    fill: "url(#paint3_linear_2162_30717)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65.5L143 84.7V126.3L107 145.5M107 65.5L71 84.7V126.3L107 145.5M107 65.5V145.5M67 128.7L147 82.3M67 82.3L147 128.7",
    stroke: "#050505",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0639 202.136V222.5H77.2401L66.8892 207.565H66.7003V222.5H63.6278V202.136H66.4716L76.8324 217.091H77.0213V202.136H80.0639ZM84.3072 222.5V207.227H87.2802V222.5H84.3072ZM84.5856 205.189L86.9123 200.605H90.0444L86.962 205.189H84.5856ZM104.345 207.227L98.8068 222.5H95.625L90.0767 207.227H93.2685L97.1364 218.98H97.2955L101.153 207.227H104.345ZM113.202 222.808C111.697 222.808 110.401 222.487 109.314 221.844C108.234 221.194 107.399 220.283 106.809 219.109C106.225 217.929 105.934 216.547 105.934 214.963C105.934 213.399 106.225 212.02 106.809 210.827C107.399 209.634 108.221 208.702 109.275 208.033C110.335 207.363 111.575 207.028 112.993 207.028C113.855 207.028 114.69 207.171 115.499 207.456C116.308 207.741 117.033 208.188 117.676 208.798C118.319 209.408 118.827 210.2 119.198 211.175C119.569 212.143 119.755 213.319 119.755 214.705V215.759H107.614V213.531H116.841C116.841 212.749 116.682 212.056 116.364 211.453C116.046 210.843 115.598 210.363 115.022 210.011C114.452 209.66 113.782 209.484 113.013 209.484C112.178 209.484 111.449 209.69 110.826 210.101C110.209 210.505 109.732 211.036 109.394 211.692C109.062 212.341 108.897 213.047 108.897 213.81V215.55C108.897 216.571 109.076 217.439 109.434 218.155C109.798 218.871 110.305 219.418 110.955 219.795C111.605 220.167 112.364 220.352 113.232 220.352C113.795 220.352 114.309 220.273 114.773 220.114C115.237 219.948 115.638 219.703 115.976 219.378C116.314 219.053 116.573 218.652 116.752 218.175L119.566 218.682C119.34 219.51 118.936 220.236 118.353 220.859C117.776 221.476 117.05 221.956 116.175 222.301C115.307 222.639 114.316 222.808 113.202 222.808ZM126.026 202.136V222.5H123.053V202.136H126.026ZM137.396 222.5V220.273L144.287 213.134C145.023 212.358 145.629 211.679 146.107 211.095C146.59 210.505 146.952 209.945 147.19 209.415C147.429 208.884 147.548 208.321 147.548 207.724C147.548 207.048 147.389 206.465 147.071 205.974C146.753 205.477 146.319 205.096 145.768 204.831C145.218 204.559 144.598 204.423 143.909 204.423C143.18 204.423 142.544 204.572 142 204.871C141.456 205.169 141.039 205.59 140.747 206.134C140.455 206.677 140.31 207.313 140.31 208.043H137.376C137.376 206.803 137.661 205.719 138.232 204.791C138.802 203.863 139.584 203.144 140.578 202.634C141.572 202.116 142.703 201.858 143.969 201.858C145.248 201.858 146.375 202.113 147.349 202.624C148.33 203.127 149.096 203.817 149.646 204.692C150.196 205.56 150.472 206.541 150.472 207.635C150.472 208.391 150.329 209.13 150.044 209.852C149.766 210.575 149.278 211.38 148.582 212.268C147.886 213.15 146.919 214.221 145.679 215.48L141.632 219.716V219.865H150.8V222.5H137.396Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30717",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C205A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30717",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_30717",
    x1: 106.25,
    y1: 64.5,
    x2: 106.25,
    y2: 145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C205A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2162_30717",
    x1: 107,
    y1: 65.5,
    x2: 107,
    y2: 145.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C205A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaTerror2);
export default __webpack_public_path__ + "static/media/Medalha_terror_2.7f36873297fcfdd3b0da15b3503b2aba.svg";
export { ForwardRef as ReactComponent };